import { createUseStyles } from 'react-jss';
import { designTokens } from '@align-cpf/uikit-styles';

const { spacing } = designTokens;

import {
  desktopLargeStyles,
  desktopSmallStyles,
  mobileStyles,
  tabletLandscapeStyles,
  tabletPortraitStyles,
  watchStyles,
} from '../../../utils';

const colWidth = {
  '1/12': '8.33333333%',
  '2/12': '16.66666667%',
  '3/12': '25%',
  '4/12': '33.33333333%',
  '5/12': '41.66666667%',
  '6/12': '50%',
  '7/12': '58.33333333%',
  '8/12': '66.66666667%',
  '9/12': '75%',
  '10/12': '83.33333333%',
  '11/12': '91.66666667%',
};

const watchGutter = spacing['--sp02'];
const gutter = spacing['--sp04'];

export default createUseStyles(
  {
    root: {
      width: '100%',
      margin: [0, 'auto'],
      maxWidth: 1328,
    },

    withPanel: {
      maxWidth: 1088,
    },

    row: {
      display: 'flex',
      flexWrap: 'wrap',
      flexBasis: '100%',
      flexDirection: 'row',
      margin: [0, `calc(-${watchGutter} / 2)`],
      ...mobileStyles({
        margin: [0, `calc(-${gutter} / 2)`],
      }),
    },

    col: {
      boxSizing: 'border-box',
      flex: '0 0 100%',
      maxWidth: '100%',
      padding: [0, `calc(${watchGutter} / 2)`],
      ...mobileStyles({
        padding: [0, `calc(${gutter} / 2)`],
      }),
    },

    xxs1: {
      ...watchStyles({
        flexBasis: colWidth['6/12'],
        maxWidth: colWidth['6/12'],
      }),
    },

    xxs2: {
      ...watchStyles({
        flexBasis: '100%',
        maxWidth: '100%',
      }),
    },

    xs1: {
      ...mobileStyles({
        flexBasis: colWidth['3/12'],
        maxWidth: colWidth['3/12'],
      }),
    },

    xs2: {
      ...mobileStyles({
        flexBasis: colWidth['6/12'],
        maxWidth: colWidth['6/12'],
      }),
    },

    xs3: {
      ...mobileStyles({
        flexBasis: colWidth['9/12'],
        maxWidth: colWidth['9/12'],
      }),
    },

    xs4: {
      ...mobileStyles({
        flexBasis: '100%',
        maxWidth: '100%',
      }),
    },

    sm1: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['1/12'],
        maxWidth: colWidth['1/12'],
      }),
    },
    sm2: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['2/12'],
        maxWidth: colWidth['2/12'],
      }),
    },
    sm3: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['3/12'],
        maxWidth: colWidth['3/12'],
      }),
    },
    sm4: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['4/12'],
        maxWidth: colWidth['4/12'],
      }),
    },
    sm5: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['5/12'],
        maxWidth: colWidth['5/12'],
      }),
    },
    sm6: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['6/12'],
        maxWidth: colWidth['6/12'],
      }),
    },
    sm7: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['7/12'],
        maxWidth: colWidth['7/12'],
      }),
    },
    sm8: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['8/12'],
        maxWidth: colWidth['8/12'],
      }),
    },
    sm9: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['9/12'],
        maxWidth: colWidth['9/12'],
      }),
    },
    sm10: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['10/12'],
        maxWidth: colWidth['10/12'],
      }),
    },
    sm11: {
      ...tabletPortraitStyles({
        flexBasis: colWidth['11/12'],
        maxWidth: colWidth['11/12'],
      }),
    },
    sm12: {
      ...tabletPortraitStyles({
        flexBasis: '100%',
        maxWidth: '100%',
      }),
    },

    md1: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['1/12'],
        maxWidth: colWidth['1/12'],
      }),
    },
    md2: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['2/12'],
        maxWidth: colWidth['2/12'],
      }),
    },
    md3: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['3/12'],
        maxWidth: colWidth['3/12'],
      }),
    },
    md4: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['4/12'],
        maxWidth: colWidth['4/12'],
      }),
    },
    md5: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['5/12'],
        maxWidth: colWidth['5/12'],
      }),
    },
    md6: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['6/12'],
        maxWidth: colWidth['6/12'],
      }),
    },
    md7: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['7/12'],
        maxWidth: colWidth['7/12'],
      }),
    },
    md8: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['8/12'],
        maxWidth: colWidth['8/12'],
      }),
    },
    md9: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['9/12'],
        maxWidth: colWidth['9/12'],
      }),
    },
    md10: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['10/12'],
        maxWidth: colWidth['10/12'],
      }),
    },
    md11: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['11/12'],
        maxWidth: colWidth['11/12'],
      }),
    },
    md12: {
      ...tabletLandscapeStyles({
        flexBasis: '100%',
        maxWidth: '100%',
      }),
    },

    lg1: {
      ...desktopSmallStyles({
        flexBasis: colWidth['1/12'],
        maxWidth: colWidth['1/12'],
      }),
    },
    lg2: {
      ...desktopSmallStyles({
        flexBasis: colWidth['2/12'],
        maxWidth: colWidth['2/12'],
      }),
    },
    lg3: {
      ...desktopSmallStyles({
        flexBasis: colWidth['3/12'],
        maxWidth: colWidth['3/12'],
      }),
    },
    lg4: {
      ...desktopSmallStyles({
        flexBasis: colWidth['4/12'],
        maxWidth: colWidth['4/12'],
      }),
    },
    lg5: {
      ...desktopSmallStyles({
        flexBasis: colWidth['5/12'],
        maxWidth: colWidth['5/12'],
      }),
    },
    lg6: {
      ...desktopSmallStyles({
        flexBasis: colWidth['6/12'],
        maxWidth: colWidth['6/12'],
      }),
    },
    lg7: {
      ...desktopSmallStyles({
        flexBasis: colWidth['7/12'],
        maxWidth: colWidth['7/12'],
      }),
    },
    lg8: {
      ...desktopSmallStyles({
        flexBasis: colWidth['8/12'],
        maxWidth: colWidth['8/12'],
      }),
    },
    lg9: {
      ...desktopSmallStyles({
        flexBasis: colWidth['9/12'],
        maxWidth: colWidth['9/12'],
      }),
    },
    lg10: {
      ...desktopSmallStyles({
        flexBasis: colWidth['10/12'],
        maxWidth: colWidth['10/12'],
      }),
    },
    lg11: {
      ...tabletLandscapeStyles({
        flexBasis: colWidth['11/12'],
        maxWidth: colWidth['11/12'],
      }),
    },
    lg12: {
      ...tabletLandscapeStyles({
        flexBasis: '100%',
        maxWidth: '100%',
      }),
    },

    xl1: {
      ...desktopLargeStyles({
        flexBasis: colWidth['1/12'],
        maxWidth: colWidth['1/12'],
      }),
    },
    xl2: {
      ...desktopLargeStyles({
        flexBasis: colWidth['2/12'],
        maxWidth: colWidth['2/12'],
      }),
    },
    xl3: {
      ...desktopLargeStyles({
        flexBasis: colWidth['3/12'],
        maxWidth: colWidth['3/12'],
      }),
    },
    xl4: {
      ...desktopLargeStyles({
        flexBasis: colWidth['4/12'],
        maxWidth: colWidth['4/12'],
      }),
    },
    xl5: {
      ...desktopLargeStyles({
        flexBasis: colWidth['5/12'],
        maxWidth: colWidth['5/12'],
      }),
    },
    xl6: {
      ...desktopLargeStyles({
        flexBasis: colWidth['6/12'],
        maxWidth: colWidth['6/12'],
      }),
    },
    xl7: {
      ...desktopLargeStyles({
        flexBasis: colWidth['7/12'],
        maxWidth: colWidth['7/12'],
      }),
    },
    xl8: {
      ...desktopLargeStyles({
        flexBasis: colWidth['8/12'],
        maxWidth: colWidth['8/12'],
      }),
    },
    xl9: {
      ...desktopLargeStyles({
        flexBasis: colWidth['9/12'],
        maxWidth: colWidth['9/12'],
      }),
    },
    xl10: {
      ...desktopLargeStyles({
        flexBasis: colWidth['10/12'],
        maxWidth: colWidth['10/12'],
      }),
    },
    xl11: {
      ...desktopLargeStyles({
        flexBasis: colWidth['11/12'],
        maxWidth: colWidth['11/12'],
      }),
    },
    xl12: {
      ...desktopLargeStyles({
        flexBasis: '100%',
        maxWidth: '100%',
      }),
    },
  },

  {
    name: 'Grid',
  },
);
